import NotesList from './NotesList';

export default NotesList;
